<template lang="pug">
  .product-card(:class="{ 'set-width': setWidth }")
    .prod-card-wrap.ui-color-3-bg.text-center(v-if="prodObj.id")
      .prod-info-wrap
        p.prod-title.xs-f-xmedium.max-at-tweak.bold {{ prodTitle }}
        p.xs-f-xsmall.max-at-tweak.text-color-3 {{ prodSubTitle }}

      .prod-img-wrap
        .a-box-xs-1x1
          .a-box-content
            img-box(:media-obj="prodObj?.imagery?.standard")

      button.mr-btn.btn-block.max-at-tweak.purchase-btn.xs-f-xxsmall.xs-mt-150m(ref="addButton" @click="addToBag")
        span Add To Bag
        span.from-text.lower.normal {{ $currency(prodObj?.price) }}

      MrSpinnerVeil(v-if="showSpinner")

</template>

<script>
  import MrSpinnerVeil from "@components/MrSpinnerVeil";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "ProductCard",
    components: {MrSpinnerVeil},

    props: {
      prodObj: {
        type: Object,
        required: true,
        default: () => ({})
      },

      overrides: {
        type: Object,
        default: () => ({})
      },

      setWidth: {
        type: Boolean,
        default: true
      },

      trackEventName: {
        type: String,
        default: 'Product Card'
      }
    },

    computed: {
      ...mapState('cart', [
        'addingProduct'
      ]),

      prodTitle() {
        return this.overrides.titleOverride? this.overrides.titleOverride : this.prodObj?.product_type_display_name;
      },

      prodSubTitle() {
        return this.overrides.subTitleOverride? this.overrides.subTitleOverride : this.prodObj?.name;
      },

      showSpinner() {
        return this.prodObj.id && this.addingProduct === this.prodObj.id;
      }
    },

    methods: {
      ...mapActions(['notifySuccess']),
      ...mapActions('cart', ['addToCart']),

      addToBag() {
        if (this.addingProduct) {
          return;
        }

        let payload = {
          productId: this.prodObj.id,
          ctaSource: 'Product Card',
          cartType: 'active',
        };

        this.addingToCart = this.prodObj.id;

        this.addToCart(payload).then(this.onItemAddedToTheBag);
      },

      onItemAddedToTheBag() {
        this.addingToCart = null;
        this.trackMREvent(this.trackEventName);
        this.notifySuccess('Item has been added to your bag.');
      },
    }
  };

</script>

<style scoped lang="stylus">
  .product-card
    &.set-width
      padding 0 0.5em
      width 15em

    .prod-card-wrap
      padding 1em
      border-radius 5px
      max-width 20em

    .prod-info-wrap
      height 6.5em

      .prod-title
        line-height normal

    .prod-img-wrap
      max-width 10.5em
      margin 0 auto

    .purchase-btn
      padding-top 0.4em
      padding-bottom 1.6em

      .from-text
        position absolute
        left 0
        right 0
        top 1.7em

</style>